import React from 'react';
import {
    Document,
    Page,
    Text,
    View,
    Image,
    StyleSheet,
    PDFViewer,
    Font
  } from "@react-pdf/renderer";
import { Container, Row, Col } from "reactstrap"
import profile from "assets/images/bridge-logo.png";
  

  const styles = StyleSheet.create({
	page: {
		flexDirection: 'column',
        padding: '40px'
	},
	sectionHead: {	
        margin:1,  
	},
    section: {	
        margin:1,
        textAlign: 'center',   
	},
    image: {
        width: "50%",
        padding: 10
    },
    centerImage: {
        alignItems: "center"
    },
    text: {

        width: "100%",
        backgroundColor: "#f0f0f0",
        paddingHorizontal: 50,
        paddingVertical: 30,
        color: "#212121"
    },
    title: {
        fontWeight: 900,
        fontSize:"16px",
        width: "100%",
        paddingHorizontal: 50,
        paddingVertical: 10
    },
    viewer: {
        width: "100%", //the pdf viewer will take up all of the width and height
        height: window.innerHeight
    }
});
const ViewLeaveReport = () => {

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-5">
   
      <Container fluid={true}>
        <Row>
            <Col lg="12">

            <PDFViewer style={styles.viewer}>
                <Document title="MUG Posted Leave" author="BRIDGE" file="/temp/">
                   
                </Document>
            </PDFViewer>
            </Col>
          </Row>
         

        </Container>
      </div>
    </React.Fragment>
  )
}
export default ViewLeaveReport;